$j = jQuery.noConflict();
document.addEventListener('DOMContentLoaded', function () {
    'use strict';
    // --------------
    // variables
    // --------------
    const $hamburger = document.getElementById('hamburger');
    const select = document.getElementById('country');
    const animations = document.querySelectorAll('.scroll');
    const html = document.getElementsByTagName('html')[0];
    const selectContact =  document.querySelector('.contact__input--select');
    const lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy',
    });
    if (typeof select != 'undefined' && select != null) {
        new SlimSelect({
            select: '#country',

        });
    }
    $hamburger.addEventListener('click', function () {
        $hamburger.classList.toggle('hamburger--open');
        console.log(html)
        html.classList.toggle('overflow');

    });

    /*
    About Us - our team slider bottom
     */
    function moveToSelected(element) {
        if (element == 'team__next') {
            var selected = $j('.team__selected').next();
        } else if (element == 'team__prev') {
            var selected = $j('.team__selected').prev();
        } else {
            var selected = element;
        }

        var next = $j(selected).next();
        var prev = $j(selected).prev();
        var prevSecond = $j(prev).prev();
        var nextSecond = $j(next).next();

        $j(selected).removeClass().addClass('team__selected');

        $j(prev).removeClass().addClass('team__prev');
        $j(next).removeClass().addClass('team__next');


        $j(next).nextAll().removeClass().addClass('team__hideRight');
        $j(prev).prevAll().removeClass().addClass('team__hideLeft');
    }
    var inputs = $j('.contact__input').keypress(function(e){
        if (e.which == 13) {
            e.preventDefault();
            var nextInput = inputs.get(inputs.index(this) + 1);
            if (nextInput) {
                nextInput.focus();
            }
        }
    });
    if (typeof selectContact != 'undefined' && selectContact != null) {
        selectContact.addEventListener('change', (e)=> {
            e.preventDefault();
            console.log('e')
            $j('#subject').focus();
        })
    }

setTimeout(() => {
    $j('.contact__form div.wpcf7-response-output').hide();
},4000)
    // $j(document).keydown(function (e) {
    //     switch (e.which) {
    //         case 37: // left
    //             moveToSelected('team__prev');
    //             const lastSlide = $j('#team-carousel > div').last();
    //             const carouseleContainerPrev = $j('#team-carousel').prepend(lastSlide);
    //             lastSlide.removeClass('team__hideRight');
    //             lastSlide.addClass('team__hideLeft');
    //
    //             setTimeout(() => {
    //                 lastSlide.removeClass('team__hideLeft');
    //                 lastSlide.addClass('team__prev');
    //             }, 100);
    //             break;
    //
    //         case 39: // right
    //             moveToSelected('team__next');
    //             const firstSlide = $j('#team-carousel > div').first();
    //             const carouseleContainer = $j('#team-carousel').append(firstSlide);
    //             firstSlide.addClass('team__hideRight');
    //             firstSlide.removeClass('team__hideLeft');
    //
    //
    //             break;
    //
    //         default:
    //             return;
    //     }
    //     e.preventDefault();
    // });

    $j('#team-carousel > div').click(function () {
        if ($j(this).hasClass('team__selected')) {
            return false;
        } else if ($j(this).hasClass('team__next')) {
            const firstSlide = $j('#team-carousel > div').first();
            const carouseleContainer = $j('#team-carousel').append(firstSlide);
            firstSlide.removeClass();
            moveToSelected($j(this));
            firstSlide.addClass('team__hideRight');
            firstSlide.addClass('team__next');
            setTimeout(() => {
                firstSlide.removeClass('team__hideRight');
            }, 100);



        } else {

            const lastSlide = $j('#team-carousel > div').last();
            lastSlide.removeClass('team__hideRight');
            const carouseleContainerPrev = $j('#team-carousel').prepend(lastSlide);
            moveToSelected($j(this));
            lastSlide.removeClass();
            lastSlide.addClass('team__hideLeft');
            lastSlide.addClass('team__prev');
            setTimeout(() => {
                lastSlide.removeClass('team__hideLeft');

            }, 190);
        }
    });

    $j('#team-carousel').on('swiped-left',function() {

        const firstSlide = $j('#team-carousel > div').first();
        const carouseleContainer = $j('#team-carousel').append(firstSlide);
        firstSlide.removeClass();
        moveToSelected('team__next');
        firstSlide.addClass('team__hideRight');
        firstSlide.addClass('team__next');
        setTimeout(() => {
            firstSlide.removeClass('team__hideRight');
        }, 30);




    })
    $j('#team-carousel').on('swiped-right',function() {
        const lastSlide = $j('#team-carousel > div').last();
        const carouseleContainerPrev = $j('#team-carousel').prepend(lastSlide);
        moveToSelected('team__prev');
        lastSlide.removeClass();
        lastSlide.removeClass('team__hideRight');
        lastSlide.addClass('team__prev');






    })
    $j(document).ready(function () {
        $j('.news__list li').each(function () {
            if ($j(this).children().hasClass('current')) {
                $j(this).addClass('news__item news__item--active');
            } else {
                $j(this).addClass('news__item');
            }
        });

    })

    //hero slider


    function moveToSelected2(element) {

        if (element == "next") {
            var selected = $j(".selected").next();
        } else if (element == "prev") {
            var selected = $j(".selected").prev();
        } else {
            var selected = element;
        }

        var next = $j(selected).next();
        var prev = $j(selected).prev();
        var prevSecond = $j(prev).prev();
        var nextSecond = $j(next).next();

        $j(selected).removeClass().addClass("selected");

        $j(prev).removeClass().addClass("prev");
        $j(next).removeClass().addClass("next");


        $j(next).nextAll().removeClass().addClass('hideRight');
        $j(prev).prevAll().removeClass().addClass('hideLeft');

    }



    $j('#carousel-hero > div').click(function () {
        if ($j(this).hasClass('selected')) {

        } else if ($j(this).hasClass('next')) {
            const firstSlide = $j('#carousel-hero > div').first();
            const carouseleContainer = $j('#carousel-hero').append(firstSlide);
            firstSlide.removeClass();
           setTimeout(()=> {
               firstSlide.removeClass('hideLeft');
               firstSlide.addClass('hideRight');
           },100)


            moveToSelected2($j(this));
        } else {
            const lastSlide = $j('#carousel-hero > div').last();
            lastSlide.removeClass('hideRight');
            const carouseleContainerPrev = $j('#carousel-hero').prepend(lastSlide);
            moveToSelected2($j(this));

            lastSlide.removeClass();
            lastSlide.addClass('hideLeft');
            setTimeout(() => {
                lastSlide.removeClass('hideLeft');
                lastSlide.addClass('prev');
            }, 100);

        }
    });

    $j('#carousel-hero').on('swiped-left',function() {

        const firstSlide = $j('#carousel-hero > div').first();
        const carouseleContainer = $j('#carousel-hero').append(firstSlide);
        firstSlide.addClass('hideRight');
        firstSlide.removeClass('hideLeft');

        moveToSelected2('next');
    })
    $j('#carousel-hero').on('swiped-right',function() {
        const lastSlide = $j('#carousel-hero > div').last();
        lastSlide.removeClass('hideRight');
        const carouseleContainerPrev = $j('#carousel-hero').prepend(lastSlide);
        lastSlide.addClass('hideLeftBig');
        moveToSelected2('prev');
        // lastSlide.removeClass();

        setTimeout(() => {
            lastSlide.addClass('prev');
        }, 100);
    })

//smoothy scroll aniamtions
    for( let i = 0; i < animations.length; i++){
        let timing = animations[i].getAttribute('data-speed');

        let instance = basicScroll.create({
            elem: animations[i],
            from: 'bottom-bottom',
            to: 'top-top',
            direct: true,
            props: {
                '--tx': {
                    from: '10px',
                    to: '-10px',
                    timing: (t)=> t * timing,
                }
            }
        })


        instance.start()
    }

    $j(document).ready(function() {
      $j("main").removeClass("preload");
    });
    // const math = {
    //     lerp: (a, b, n) => {
    //         return (1 - n) * a + n * b
    //     },
    //     norm: (value, min, max) => {
    //         return (value - min) / (max - min)
    //     }
    // }
    //
    // const config = {
    //     height: window.innerHeight,
    //     width: window.innerWidth
    // }
    //
    // class Smooth {
    //     constructor() {
    //         this.bindMethods()
    //
    //         this.data = {
    //             ease: 0.1,
    //             current: 0,
    //             last: 0
    //         }
    //
    //         this.dom = {
    //             el: document.querySelector('[data-scroll]'),
    //             content: document.querySelector('[data-scroll-content]')
    //         }
    //
    //         this.rAF = null
    //
    //         this.init()
    //     }
    //
    //     bindMethods() {
    //         ['scroll', 'run', 'resize']
    //             .forEach((fn) => this[fn] = this[fn].bind(this))
    //     }
    //
    //     setStyles() {
    //         Object.assign(this.dom.el.style, {
    //             position: 'fixed',
    //             top: 0,
    //             left: 0,
    //             height: '100%',
    //             width: '100%',
    //             overflow: 'hidden'
    //         })
    //     }
    //
    //     setHeight() {
    //         document.body.style.height = `${this.dom.content.offsetHeight}px`
    //     }
    //
    //     resize() {
    //         this.setHeight()
    //         this.scroll()
    //     }
    //
    //     preload() {
    //         imagesLoaded(this.dom.content, (instance) => {
    //             this.setHeight()
    //         })
    //     }
    //
    //     scroll() {
    //         this.data.current = window.scrollY
    //     }
    //
    //     run() {
    //         this.data.last = math.lerp(this.data.last, this.data.current, this.data.ease)
    //         if (this.data.last < .1) {
    //             this.data.last = 0
    //         }
    //
    //         const diff = this.data.current - this.data.last
    //         const acc = diff / config.width
    //         const velo =+ acc
    //         const skew = velo * (-7.5)
    //
    //         this.dom.content.style.transform = `translate3d(0, -${this.data.last}px, ${skew}px)`
    //
    //         this.requestAnimationFrame()
    //     }
    //
    //     on() {
    //         this.setStyles()
    //         this.setHeight()
    //         this.addEvents()
    //
    //         this.requestAnimationFrame()
    //     }
    //
    //     off() {
    //         this.cancelAnimationFrame()
    //
    //         this.removeEvents()
    //     }
    //
    //     requestAnimationFrame() {
    //         this.rAF = requestAnimationFrame(this.run)
    //     }
    //
    //     cancelAnimationFrame() {
    //         cancelAnimationFrame(this.rAF)
    //     }
    //
    //     destroy() {
    //         document.body.style.height = ''
    //
    //         this.data = null
    //
    //         this.removeEvents()
    //         this.cancelAnimationFrame()
    //     }
    //
    //     resize() {
    //         this.setHeight()
    //     }
    //
    //     addEvents() {
    //         window.addEventListener('resize', this.resize, { passive: true })
    //         window.addEventListener('scroll', this.scroll, { passive: true })
    //     }
    //
    //     removeEvents() {
    //         window.removeEventListener('resize', this.resize, { passive: true })
    //         window.removeEventListener('scroll', this.scroll, { passive: true })
    //     }
    //
    //     init() {
    //         this.preload()
    //         this.on()
    //     }
    // }
    //
    // new Smooth()
    // --------------
    // functions
    // --------------
    // $j(".scroll").inertiaScroll({
    //     parent: $j(".parent")
    // });

    function bodyAnim() {
        setTimeout(() => {
            document.body.classList.add('uk-animation-slide-top-small-custom');
            setTimeout(() => {
                document.body.style.opacity = 1;
                document.body.classList.remove('uk-animation-slide-top-small-custom');
            }, 350);
        }, 250);
    }
    bodyAnim();
    // --------------
    // event listners & starters
    // --------------
    // fires lazy load
    if (lazyLoadInstance) {
        lazyLoadInstance.update();
    }
});
